import type { ReactElement } from "react";
import { ProfileCard } from "./ProfileCard";
import { OrganisationCard } from "./OrganisationCard";
import { useBreakpoint } from "../../lib/useBreakpoint";
import styles from "./AccountView.module.css";

export function AccountView(): ReactElement {
  const { isMobile } = useBreakpoint();

  if (isMobile) {
    // Mobile omits the page heading (the app bar shows it) and trims rows.
    return (
      <div className={styles.mobile}>
        <ProfileCard compact />
        <OrganisationCard />
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <div>
        <h1 className={styles.title}>Account</h1>
        <p className={styles.intro}>
          Your Property Finder profile and the company it belongs to.
        </p>
      </div>
      <div className={styles.grid}>
        <ProfileCard />
        <OrganisationCard />
      </div>
    </div>
  );
}
